import { AccountType } from 'further-types/investor';
import useVehicleApplication from 'hooks/lp/data/vehicleApplication/useVehicleApplication';
import KycDetails from './KycDetails';
import KybDetails from './KybDetails';
import {
  OnboardingStep,
  OnboardingStepStatus,
} from 'further-types/lp/onboarding';
import { Column } from 'further-ui/components/Layout';
import { Disclosure } from 'further-ui/hooks';

type Props = {
  vehicleId: string;
  vehicleApplicationId: string;
  manualKycDisclosure: Disclosure;
};
const KycOrKybDetails: React.FC<Props> = ({
  vehicleId,
  vehicleApplicationId,
  manualKycDisclosure,
}) => {
  const { vehicleApplication, investor } = useVehicleApplication(
    vehicleId,
    vehicleApplicationId,
  );

  const isInformationCompleted = [
    OnboardingStepStatus.InReview,
    OnboardingStepStatus.Completed,
  ].includes(
    vehicleApplication.applicationSteps.find(
      (step) => step.step === OnboardingStep.KYCOrKYB,
    )?.status ?? OnboardingStepStatus.Disabled,
  );

  const isStepCompleted =
    vehicleApplication.applicationSteps.find(
      (step) => step.step === OnboardingStep.KYCOrKYB,
    )?.status === OnboardingStepStatus.Completed;

  return (
    <Column fullWidth spacing="md">
      {investor.accountType === AccountType.Individual ? (
        <KycDetails
          vehicleId={vehicleId}
          vehicleApplicationId={vehicleApplicationId}
          investorId={investor.id}
          isStepCompleted={isStepCompleted}
          manualKycDisclosure={manualKycDisclosure}
          fullName={`${investor.firstName} ${investor.lastName}`}
        />
      ) : (
        <KybDetails
          vehicleId={vehicleId}
          investorId={investor.id}
          vehicleApplicationId={vehicleApplicationId}
          isInformationCompleted={isInformationCompleted}
          manualKycDisclosure={manualKycDisclosure}
        />
      )}
    </Column>
  );
};

export default KycOrKybDetails;
